import { useMemoizedFn } from 'ahooks';
import React, { useEffect } from 'react';
import styled from 'styled-components';
import { Table, Form, Input } from 'tdesign-react';
import { renderByte } from '@/utils/common';
import { getDataLogs } from '@/services/kafkaBrokerService';
import useTable from '@/hooks/useTable';

export default function DataLogs({ brokerId, clusterName }) {
  const columns = [
    {
      title: 'Folder',
      align: 'left',
      width: 300,
      colKey: 'folder',
    },
    {
      title: 'Topic',
      colKey: 'topic',
    },
    {
      title: 'Partition',
      colKey: 'partition',
      width: 110,
    },
    {
      title: 'Offset Lag',
      colKey: 'offsetLag',
      width: 110,
    },
    {
      title: 'Size',
      colKey: 'size',
      width: 110,
      cell: renderByte,
    },
  ];

  const loadData = useMemoizedFn(async (params) => {
    const { data } = await getDataLogs({
      ...params,
      clusterName,
      brokerId,
    });
    setData(data);
  });

  const { config, header, setData, doSearch } = useTable({
    columns,
    onSearch: loadData,
    search: (
      <>
        <Form.FormItem name='topicName'>
          <Input placeholder='请输入Topic' clearable />
        </Form.FormItem>
      </>
    ),
  });

  useEffect(() => {
    doSearch();
  }, [doSearch]);

  return (
    <Root>
      {header}
      <Table {...config} />
    </Root>
  );
}

const Root = styled.div`
  padding-top: 18px;
`;
